import app from 'flarum/forum/app';
/** Event names as flarum/realtime and the bundled extensions broadcast them. */
export const STARTED = 'Flarum\\Discussion\\Event\\Started';
export const POSTED = 'Flarum\\Post\\Event\\Posted';
export const REVISED = 'revisedEvent';
export const LIKED = 'likesMutation';
export const RENAMED = 'discussionRenamed';
export const TAGGED = 'taggedEvent';
export const NOTIFICATION = 'notification';
export const POST_HIDDEN = 'postHidden';
export const POST_RESTORED = 'postRestored';
export const DISCUSSION_HIDDEN = 'discussionHidden';
export const DISCUSSION_RESTORED = 'discussionRestored';
/** Something the member could see has been hidden or deleted: `{ data: { type, id } }` only. */
export const REMOVED = 'removed';

/**
 * Events about a post. Realtime sends these as the post's *discussion*, with
 * the post itself appended last to `included`.
 */
export const POST_EVENTS = [POSTED, REVISED, LIKED, POST_HIDDEN, POST_RESTORED];

/** The post an event is about: for post events, the one appended last to `included`. */
export function subjectPost(name, payload) {
  if (!POST_EVENTS.includes(name)) return null;
  const included = payload?.included ?? [];
  for (let i = included.length - 1; i >= 0; i--) {
    if (included[i]?.type === 'posts') return app.store.getById('posts', String(included[i].id)) ?? null;
  }
  return null;
}

/** A to-one relationship's id straight from the model's data, without needing the related model loaded. */
export function relatedId(model, relationship) {
  return model.data?.relationships?.[relationship]?.data?.id ?? null;
}
export function postOf(event) {
  return event.post;
}
export function discussionOf(event) {
  return event.discussion;
}
flarum.reg.add('flarum-deck', 'forum/columns/realtimeEvents', { STARTED: STARTED,POSTED: POSTED,REVISED: REVISED,LIKED: LIKED,RENAMED: RENAMED,TAGGED: TAGGED,NOTIFICATION: NOTIFICATION,POST_HIDDEN: POST_HIDDEN,POST_RESTORED: POST_RESTORED,DISCUSSION_HIDDEN: DISCUSSION_HIDDEN,DISCUSSION_RESTORED: DISCUSSION_RESTORED,REMOVED: REMOVED,POST_EVENTS: POST_EVENTS,subjectPost: subjectPost,relatedId: relatedId,postOf: postOf,discussionOf: discussionOf, });